module.exports = __webpack_public_path__ + "media/icons/triangle_border-blue-c56c02f7.svg";